<div class="app-root">
  <router-outlet></router-outlet>
</div>
